import Glide from "@glidejs/glide";

document.addEventListener("DOMContentLoaded", () => {
  // 1) Meet the team carousel (single)
  const meetTheTeam = document.querySelector(".glide-meet-the-team");
  if (meetTheTeam) {
    const glideMeetTheTeam = new Glide(meetTheTeam, {
      type: "carousel",
      perView: 6,
      focusAt: "center",
      animationDuration: 800,
      gap: 48,
      breakpoints: {
        1400: { perView: 4 },
        720: { perView: 2 },
      },
    });

    glideMeetTheTeam.mount();
  }

  // 2) Data-attribute-driven glides (multiple)
  const glideEls = document.querySelectorAll(".glide-screens");
  if (!glideEls.length) return; // OK now because we're inside a function

  glideEls.forEach((el) => {
    if (el.dataset.glideMounted === "true") return;

    const type = el.dataset.type || "carousel";
    const perView = parseInt(el.dataset.perView, 10) || 1;
    const gap = parseInt(el.dataset.gap, 10) || 0;
    const breakpoint = el.dataset.breakpoint ? parseInt(el.dataset.breakpoint, 10) : null;

    let glideInstance = null;

    function mount() {
      if (glideInstance) return;
      glideInstance = new Glide(el, { type, perView, gap });
      glideInstance.mount();
      el.dataset.glideMounted = "true";
    }

    function destroy() {
      if (!glideInstance) return;
      glideInstance.destroy();
      glideInstance = null;
      el.dataset.glideMounted = "false";
    }

    if (!breakpoint) {
      mount();
      return;
    }

    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);

    function handle(e) {
      e.matches ? mount() : destroy();
    }

    handle(mq);
    mq.addEventListener("change", handle);
  });
});
